<template>
  <div class="app-container post-list">
    <div class="post-list-filter">
      <el-row>
        <el-col :span="6">
          <div class="grid-content bg-purple">
            <label class="post-list-filter-label">标题</label>
            <el-input class="post-list-filter-value" @keyup.enter.native="searchChange" v-model="search.title" clearable size="small"></el-input>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="grid-content bg-purple">
            <label class="post-list-filter-label">发布者</label>
            <el-input class="post-list-filter-value" @keyup.enter.native="searchChange" v-model="search.postedByName" clearable size="small"></el-input>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="grid-content bg-purple">
            <label class="post-list-filter-label">类别</label>
            <el-input class="post-list-filter-value" @keyup.enter.native="searchChange" v-model="search.tagName" clearable size="small"></el-input>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="grid-content bg-purple">
            <label class="post-list-filter-label">圈子</label>
            <el-input class="post-list-filter-value" @keyup.enter.native="searchChange" v-model="search.circleName" clearable size="small"></el-input>
          </div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="6">
          <div class="grid-content bg-purple">
            <label class="post-list-filter-label">主题</label>
            <el-input class="post-list-filter-value" @keyup.enter.native="searchChange" v-model="search.themeTagName" clearable size="small"></el-input>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="grid-content bg-purple">
            <label class="post-list-filter-label">状态</label>
            <el-select class="post-list-filter-value" placeholder="" v-model="search.status" clearable size="small">
              <el-option
                v-for="item in statusOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="grid-content bg-purple">
            <label class="post-list-filter-label">发布状态</label>
            <el-select class="post-list-filter-value" placeholder="" v-model="search.publishStatus" clearable size="small">
              <el-option
                v-for="item in publishStatusOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="grid-content bg-purple">
            <label class="post-list-filter-label">置顶</label>
            <el-select class="post-list-filter-value" placeholder="" v-model="search.top" clearable size="small">
              <el-option
                v-for="item in topOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="6">
          <div class="grid-content bg-purple">
            <label class="post-list-filter-label">过期</label>
            <el-select class="post-list-filter-value" placeholder="" v-model="search.expired" clearable size="small">
              <el-option
                v-for="item in expiredOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </div>
        </el-col>
        <el-col :span="9">
          <div class="grid-content bg-purple">
            <label class="post-list-filter-label">发布时间</label>
            <el-date-picker
               class="post-list-filter-date"
              v-model="search.searchTime"
              type="daterange"
              value-format="yyyy-MM-dd"
              start-placeholder="开始时间"
              end-placeholder="结束时间"
              size="small">
            </el-date-picker>
          </div>
        </el-col>
        <div>
          <div>
            <el-button class="post-list-filter-search" size="small" @click="searchChange">立即筛选</el-button>
            <el-button class="post-list-filter-reset" size="small" @click="searchReset">清除条件</el-button>
          </div>
        </div>
      </el-row>
    </div>

    <basic-container class = "post-list-container">
      <avue-crud ref="crud"
                 :option="postTableOption"
                 :data="tableData"
                 :page="page"
                 :table-loading="tableLoading"
                 :before-open="handleOpenBefore"
                 @current-change="handleCurrentChange"
                 @size-change="handleSizeChange"
                 @sort-change="handleSortChange">

        <template slot="title"
                  slot-scope="scope">
          <a href="javascript:void(0);" @click="handleView(scope.row,scope.index);"
              class="post-list-container-button">
            {{scope.row.title}}</a>
        </template>

        <template slot="postedByName"
                  slot-scope="scope">
          <a href="javascript:void(0);" @click="toMemberDetail(scope.row.postedBy.id);"
              class="post-list-container-button">
            {{scope.row.postedByName}}</a>
        </template>

        <template slot="circleName"
                  slot-scope="scope">
          <a href="javascript:void(0);" @click="toCircleDetail(scope.row.circleId);"
              class="post-list-container-button">
            {{scope.row.circleName}}</a>
        </template>

        <template slot="commentCount"
                  slot-scope="scope">
          <a href="javascript:void(0);" @click="toCommentList(scope.row.id);"
              class="post-list-container-button">
            {{scope.row.commentCount}}</a>
        </template>

        <template slot="commentEnabled"
                  slot-scope="scope">
          <el-switch v-model="scope.row.commentEnabled"
                     active-color="#00A854"
                     inactive-color="#F04134"
                     :disabled="!permissions.post_comment_status"
                     @change="handleCommentUpdate(scope.row,scope.index)">
          </el-switch>
        </template>

        <template slot="menuLeft">
          <el-button type="primary" @click="handleAdd" icon="el-icon-plus" size="small" v-if="permissions.post_post_add">新增</el-button>
        </template>

        <template slot="menu"
                  slot-scope="scope" width=100>
          <el-button size="mini"
                type="text"
                icon="el-icon-view"
                @click="handleView(scope.row,scope.index)">查看
          </el-button>
          <el-button size="mini"
                type="text"
                icon="el-icon-upload2"
                v-if="permissions.post_update_up && scope.row.isBanned"
                @click="handleUp(scope.row,scope.index)">上架
          </el-button>
          <el-button size="mini"
                type="text"
                icon="el-icon-download"
                v-if="permissions.post_update_down && !scope.row.isBanned"
                @click="handleDown(scope.row,scope.index)">下架
          </el-button>
          <el-button type="text"
            v-if="permissions.post_post_update"
            icon="el-icon-edit"
            size="mini"
            @click="handlePostUpdate(scope.row,scope.index)">编辑</el-button>
          <el-button type="text"
            v-if="permissions.post_post_top"
            icon="el-icon-caret-top"
            size="mini"
            @click="openTopDialog(scope.row,scope.index)">置顶</el-button>
          <el-button type="text"
            icon="el-icon-edit"
            size="mini"
            v-if="permissions.post_edit_heat"
            @click="openManualDialog(scope.row)">编辑热度</el-button>
          <el-button
            title="复制链接"
            size="mini"
            type="text"
            icon="el-icon-share"
            @click="copyLink(scope.row)">复制链接</el-button>
        </template>

      </avue-crud>
    </basic-container>

    <el-dialog
      title="置顶帖子"
      width="25%"
      :visible.sync="topPost.topDialogVisible">
      <div class="post-top-dialog">
        <div class="post-top-dialog-item">
          <label class="post-top-dialog-item-label">置顶排序</label>
          <div class="post-top-dialog-item-value">
            <el-input-number class="post-top-dialog-item-content" v-model="topPost.topPosition" placeholder="请输入置顶排序" :min="0" @change="inputNumberChange"></el-input-number>
            <div class="post-top-dialog-item-tip">
              <span>置顶请设置排序，排序为0即取消置顶</span>
            </div>
          </div>
        </div>
        <div class="post-top-dialog-item">
          <label class="post-top-dialog-item-label">过期时间</label>
          <el-date-picker
            v-model="topPost.topExpireTime"
            type="date"
            format="yyyy-MM-dd 23:59"
            :editable="false"
            :picker-options="expireTimeOption"
            :disabled="topPost.topPosition === 0"
            prefix-icon="el-icon-date"
            value-format="yyyy-MM-dd 23:59:00"
            align="center"
            class="post-top-dialog-item-content"
          >
          </el-date-picker>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="small"  @click="topPost.topDialogVisible = false">取 消</el-button>
        <el-button size="small" type="primary" @click="handlePostTop()">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog
      title="热度值"
      :visible.sync="manualDialogVisible"
      width="30%">
      <template>
        <div>
          <label class="manual-input-label">初始热度值</label>
          <el-input-number
            v-model="manualValue"
            :step="1"
            :precision="0"
            :min="0"
            @change="checkManualValue()">
          </el-input-number>
        </div>
      </template>
      <span slot="footer" class="dialog-footer">
        <el-button @click="manualDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="updateManual()">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import {fetchPostList, getPost, updatePostBanStatus,
    updatePostCommentStatus, fetchPostCommentList, updatePostTopStatus, updateManualHeatValue} from '@/api/post/post'
  import {postTableOption} from '@/const/crud/post/post'
  import {mapGetters} from "vuex";
  import {constants} from 'fs';
  import {connect} from 'tls';

  export default {
    name: "table_post",
    data() {
      return {
        //置顶时间禁用日期
        expireTimeOption: {
          disabledDate(date) {
            return date.getTime() <= Date.now() - 24 * 60 * 60 * 1000;
          }
        },
        // 搜索功能
        statusOptions: [
          { label: '已上架', value: 0 },
          { label: '已下架', value: 1 },
          { label: '已删除', value: 2 },
        ],
        publishStatusOptions: [
          { label: '草稿', value: 0 },
          { label: '已发布', value: 1 },
        ],
        topOptions: [
          { label: '是', value: 1 },
          { label: '否', value: 0 },
        ],
        expiredOptions: [
          { label: '是', value: 1 },
          { label: '否', value: 0 },
        ],
        search: {
          current: 1,
          size: 10,
          title: "",
          postedByName: "",
          tagName: "",
          circleName: "",
          status: "",
          publishStatus: "",
          searchTime: [],
          sortField: "",
          sortPolicy: "",
          themeTagName: "",
          top: "",
          expired: "",
        },

        // 列表页面
        tableData:[],
        page: {
          total: 0, // 总页数
          currentPage: 1, // 当前页数
          pageSize: 10, // 每页显示多少条,
        },
        tableLoading: false,
        postTableOption: postTableOption,
        topPost :{
          topDialogVisible: false,
          topExpireTime: '',
          topPosition: '',
          id: '',
        },
        manualDialogVisible: false,
        manualValue : 0,
        postId: ''
      };
    },
    created() {
      this.queryPosts();
    },
    computed: {
      ...mapGetters(['permissions']),
      startTime: function () {
        if (this.search.searchTime && this.search.searchTime.length > 0) {
          return this.search.searchTime[0]
        } else {
          return null
        }
      },
      endTime: function () {
        if (this.search.searchTime && this.search.searchTime.length > 1) {
          return this.search.searchTime[1]
        } else {
          return null
        }
      }
    },
    methods: {
      formatData(records) {
        // 帖子列表格式化
        let _this = this
        if (records && records.length > 0) {
          records.forEach(function(record, index) {
            if (record.postedBy) {
              record.postedByName = record.postedBy.name
              if (record.postedByName == "") {
                record.postedByName = "--"
              }
            } else {
              record.postedByName = "--"
            }

            if (record.isActive == 0) {
              record.status = '已删除'
            }
            if (record.isActive == 1 && record.isBanned == 0) {
              record.status = '已上架'
            }
            if (record.isActive == 1 && record.isBanned == 1) {
              record.status = '已下架'
            }
            if (!record.commentCount) {
              record.commentCount = 0
            }

            record.voteMemberCount = 0
            if (record.vote == undefined || record.vote == null) {
              record.voteMemberCount = "--"
            }
            if (record.vote != undefined && record.vote.voteMemberCount != undefined && record.vote.voteMemberCount) {
              record.voteMemberCount = record.vote.voteMemberCount
            }

            if (!record.favoriteCount) {
              record.favoriteCount = 0
            }
            if (record.isAnonymous == 1) {
              record.anonymousStatus = '已匿名'
            } else {
              record.anonymousStatus = '未匿名'
            }

            if (record.lastEditTime == undefined || record.lastEditTime == null) {
              record.lastEditTime = "--"
            }

            if (record.publishStatus === 1) {
              record.publishStatus = '已发布'
            } else {
              record.publishStatus = '草稿'
            }

            if (record.manualHeatValue) {
              record.manualHeatValue = parseInt(record.manualHeatValue.toFixed(0))
            } else {
              record.manualHeatValue = 0;
            }

            if (record.finalHeatValue) {
              record.finalHeatValue = parseInt(record.finalHeatValue.toFixed(0))
            } else {
              record.finalHeatValue = 0;
            }

            record.top = record.isTop ? '是' : '否'
            record.expired = record.expired ? '是' : '否'
          })
        }
        return records
      },
      getParameter(param){
        // 提取url参数值
        let url = location.href
        let reg = new RegExp("(^|&)" + param + "=([^&]*)(&|$)")
        let r = url.substr(url.indexOf("\?") + 1).match(reg)
        if (r != null) return unescape(r[2])
        else return null
      },
      getList() {
        // 获取帖子列表
        let params = {
          postType: 0, // 只查询帖子(0)列表，不查询文章(1)列表
          current: this.search.current,
          size: this.search.size
        }
        // 增加搜索功能
        if (this.search.title != "" && this.search.title.trim() != "")
          params.title = this.search.title
        if (this.search.postedByName != "" && this.search.postedByName.trim() != "")
          params.postedByName = this.search.postedByName
        if (this.search.tagName != "" && this.search.tagName.trim() != "")
          params.tagName = this.search.tagName
        if (this.search.circleName != "" && this.search.circleName.trim() != "")
          params.circleName = this.search.circleName

        if (this.search.status !== null && this.search.status !== "") {
          if (this.search.status === 0 || this.search.status === 1) {
            // 三种状态: 已上架(0)，已下架(1)，已删除(2)
            params.isBanned = this.search.status
            params.isActive = 1
          } else if (this.search.status === 2) {
            params.isActive = 0
          }
        }

        if (this.search.publishStatus !== null && this.search.publishStatus !== "") {
          // 发布状态：草稿（0），已发布（1）
          if (this.search.publishStatus === 0) {
            params.publishStatus = 0;
          } else if (this.search.publishStatus === 1) {
            params.publishStatus = 1;
          }
        }

        if (this.search.themeTagName != "" && this.search.themeTagName.trim() != "") {
          params.themeTagName = this.search.themeTagName
        }
        if (this.search.top !== null && this.search.top !== "") {
          params.top = this.search.top;
        }
        if (this.search.expired !== null && this.search.expired !== "") {
          params.expired = this.search.expired;
        }

        if (this.startTime && this.endTime) {
          params.postStartTime = this.startTime
          let t = new Date(this.endTime)
          t.setDate(t.getDate() + 1)
          params.postEndTime = t.getFullYear() + '-' + (t.getMonth() + 1) + '-' + t.getDate()
        } else {
          params.postStartTime = null
          params.postEndTime = null
        }

        // 增加排序功能
        if (this.search.sortField != "" && this.search.sortField.trim() != "")
          params.sortField = this.search.sortField
        else
          params.sortField = "post_time"
        if (this.search.sortPolicy != "" && this.search.sortPolicy.trim() != "")
          params.sortPolicy = this.search.sortPolicy
        else
          params.sortPolicy = "desc"

        // 获取url对应圈子ID参数值做筛选
        let circleIdParam = this.getParameter("circleId")
        if (circleIdParam != null && circleIdParam.trim() != "")
          params.circleId = circleIdParam
        // 获取url对应会员ID参数值做筛选
        let postedByIdParam = this.getParameter("memberId")
        if (postedByIdParam != null && postedByIdParam.trim() != "")
          params.postedBy = postedByIdParam

        this.tableLoading = true
        fetchPostList(params).then(response => {
          this.tableData = this.formatData(response.data.data.records)
          this.page.total = response.data.data.total
          this.tableLoading = false
        })
      },
      initPage() {
        this.page.currentPage = 1
        this.page.pageSize = this.search.size
        this.search.current = 1
        this.search.sortField = ""
        this.search.sortPolicy = ""
      },
      searchChange() {
        this.initPage()
        this.getList()
      },
      searchReset() {
        this.search.title = ""
        this.search.postedByName = ""
        this.search.tagName = ""
        this.search.circleName = ""
        this.search.status = null
        this.search.searchTime = []
        this.search.top = ""
        this.search.expired = ""
        this.search.publishStatus = ""
        this.searchChange()
      },
      toMemberDetail(postedById) {
        // 帖子详情里点击发布者姓名，链接转到该发布者的会员详情
        this.$router.push({
          path: "/upms/member/detail/" + postedById,
        })
      },
      toCircleDetail(circleId) {
        // 帖子详情里点击圈子名称，链接转到该圈子的详情页面
        this.$router.push({
          path: "/post/circle/detail/" + circleId,
        })
      },
      toCommentList(curPostId) {
        // 帖子详情里点击评论数，链接转到该帖子的评论列表
        this.$router.push({
          path: "/post/comment",
          query: {
            postId: curPostId
          }
        })
      },
      handleCurrentChange(val) {
        this.page.currentPage = val
        this.search.current = val
        this.getList()
      },
      handleSizeChange(val) {
        this.page.pageSize = val
        this.search.size = val
        this.getList()
      },
      handleSortChange(val) {
        // 检查排序对象
        if (val.prop == "id") {
          this.search.sortField = "post_id"
        } else if (val.prop == "commentCount") {
          this.search.sortField = "comment_count"
        } else if (val.prop == "favoriteCount") {
          this.search.sortField = "favorite_count"
        } else if (val.prop == "likeCount") {
          this.search.sortField = "like_count"
        } else if (val.prop == "viewedCount") {
          this.search.sortField = "viewed_count"
        } else if (val.prop == "postTime"){
          this.search.sortField = "post_time"
        } else if (val.prop == "manualHeatValue"){
          this.search.sortField = "manual_heat_value"
        } else if (val.prop == "autoHeatValue"){
          this.search.sortField = "auto_heat_value"
        } else if (val.prop == "finalHeatValue"){
          this.search.sortField = "final_heat_value"
        } else {
          this.search.sortField = ""
        }
        // 检查排序方式
        if (val.order == 'ascending') {
          this.search.sortPolicy = "asc"
        } else if (val.order == 'descending') {
          this.search.sortPolicy = "desc"
        } else {
          this.search.sortPolicy = ""
        }
        this.getList()
      },
      handleView(row, index) {
        if (row.id){
          this.$router.push({
            path: `/post/posts/detail/${row.id}`
          })
        } else {
          this.$message({
            showClose: true,
            message: '该帖子不存在',
            type: 'warning'
          })
        }
      },
      getPostDTO(row, inputIsBanned){
        let postDTO= {
          id: row.id,
          isBanned: inputIsBanned,
        }
        return postDTO
      },
      handleUp(row, index) {
        // 上架功能
        let postDTO = this.getPostDTO(row, 0)
        let _this = this
        this.$confirm('是否确认上架该标题为"' + row.title + '"'+ '的帖子?', '警告', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(function () {
          return updatePostBanStatus(postDTO);
        }).then(() => {
          this.getList()
          _this.$message({
            showClose: true,
            message: '上架成功',
            type: 'success'
          })
        }).catch(function () {
        })
      },
      handleDown(row, index) {
        // 下架功能
        let postDTO = this.getPostDTO(row, 1)
        let _this = this
        this.$prompt('下架原因', '下架', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          inputPattern:/^.*[^\s]+.*$/,
          inputErrorMessage: '不能为空'
        }).then(banCommentValue => {
          postDTO.banComment = banCommentValue.value
          return updatePostBanStatus(postDTO);
        }).then(response=>{
          this.getList()
          _this.$message({
            showClose: true,
            type: 'success',
            message: '下架成功'
            })
          }).catch(function () {
        })
      },
      getNodeData(data,done) {
        done()
      },
      handleOpenBefore(show, type) {
        show();
      },
      handleCommentUpdate(row, index) {
        let obj = {
          id: row.id,
          commentEnabled: row.commentEnabled,
        };
        if (row.id) {
          updatePostCommentStatus(obj);
        }
      },
      handleAdd: function() {
        this.$router.push({
          path: '/post/posts/add'
        })
      },
      handlePostUpdate(row) {
        this.$router.push({path: '/post/posts/edit', query: {id: row.id}})
      },
      openTopDialog(row) {
        this.topPost.id = row.id;
        this.topPost.topPosition = row.topPosition;
        this.topPost.topExpireTime = row.topExpireTime;
        this.topPost.topDialogVisible = true;
      },
      handlePostTop() {
        if (this.topPost.topPosition !== 0 && !this.topPost.topExpireTime) {
          this.$message({
            showClose: true,
            message: '请填写置顶日期',
            type: 'warning'
          })
          return
        }
        let successMessage = '帖子置顶成功';
        let errorMessage = '帖子置顶失败';
        if (this.topPost.topPosition === 0) {
          successMessage = '取消帖子置顶成功';
          errorMessage = '取消帖子置顶失败';
        }
        this.topPost.topDialogVisible = false;
        updatePostTopStatus(this.topPost).then(response => {
          if (response.data.code === 0 && response.data.data === true) {
            this.$message({
              showClose: true,
              message: successMessage,
              type: 'success'
            })
            this.getList();
          } else {
            this.$message({
              showClose: true,
              message: errorMessage,
              type: 'error'
            })
          }
        }).catch(error => {
          this.$message({
            showClose: true,
            message: errorMessage,
            type: 'error'
          })
        })
      },
      queryPosts() {
        if (this.$route.query.date !== undefined) {
          this.search.searchTime.push(this.$route.query.date, this.$route.query.date)
        }
        this.getList()
      },

      inputNumberChange() {
        if (this.topPost.topPosition === 0) {
          this.topPost.topExpireTime = ''
        }
      },

      openManualDialog(row) {
        this.manualDialogVisible = true
        this.manualValue = row.manualHeatValue
        this.postId = row.id
      },
      copyLink(row) {
        let url = process.env.VUE_APP_BASIC_PAGE_PATH + `/post/${row.id}`
        if (row.isVideoPost) {
          url = process.env.VUE_APP_BASIC_PAGE_PATH + `/share/video/${row.id}`
        }
        this.$copyText(url).then(
          res => {
            this.$message({
              showClose: true,
              type: 'success',
              message: '已成功复制'
            })
          },
          err => {
            this.$message({
              showClose: true,
              type: 'error',
              message: '失败'
            })
          }
        )
      },
      updateManual() {
        let params = {
          id: '',
          manual: '',
        }
        params.id = this.postId
        params.manual = this.manualValue
        if (this.manualValue > 99999999) {
          this.$message({
            showClose: true,
            message: '初始值范围为0-99999999',
            type: 'error'
          })
          return
        }
        updateManualHeatValue(params).then((res) => {
          if (res.data.data) {
            this.manualDialogVisible = false
            this.getList()
          }
        })
      },

      checkManualValue() {
        if (this.manualValue > 99999999) {
          this.$message({
            showClose: true,
            message: '初始值范围为0-99999999',
            type: 'error'
          })
        }
      }
    }
  };

</script>


<style lang="scss" scoped>

.post-list {
  &-filter {
    margin: 0px 10px;
    background-color: #fff;
    padding-top: 20px;
    padding-left: 22px;
    &-label {
      font-size: 14px;
      color: #606266;
      margin-right: 10px;
    }
    &-value {
      width: calc(100% - 90px) !important;
    }
    &-date {
      width: calc(100% - 150px) !important;
    }
    &-reset {
      float: right;
      margin-right: 8px;
    }
    &-search {
      float: right;
      margin-right: 10px;
      border-color: #5383f3;
      color: #5383f3;
    }
  }
  &-container {
    padding-top: 0px;
    &-button {
      color: #409EFF;
      font-size: 14px;
      text-align: center;
      font-weight: 500;
    }
  }
}
/deep/.el-dialog__body {
  padding : 10px 20px 40px 20px;
}
/deep/.el-input-number {
  line-height: 36px;
}
.post-top-dialog{
  height: 90px;
  &-item {
    display: flex;
    flex-direction: row;
    justify-content: center;
    &-label {
      font-size: 15px;
      color: #606266;
      padding: 10px;
    }
    &-content {
      width: 200px !important;
    }
    &-tip {
      font-size: 12px;
      color: #999999;
      margin-bottom: 10px;
      margin-top: 6px;
    }
    &-value {
      width: 200px;
    }
  }
}
.manual-input-label{
    font-size: 15px;
    color: #606266;
    padding: 10px;
}

</style>
